import TerminateSessionActions from './constants';
import { IActionObject } from './types';

const INITIAL_STATE: { terminate: boolean; errorMessage: string } = {
  terminate: false,
  errorMessage: '',
};

export default function currentStepReducer(
  state: any = INITIAL_STATE,
  action: IActionObject
): {} {
  const { data } = action;
  switch (action.type) {
    case TerminateSessionActions.TERMINATE_SESSION:
      return { terminate: data.terminate, errorMessage: data.errorMessage };
    default:
      return state;
  }
}
